// Random fun facts shown during receipt analysis. In Swiss German style (ss
// only, never ß) to match the rest of the UI. Keep each one short (≤ ~140
// chars) so it fits on one or two lines on mobile without scrolling.
export const FUN_FACTS: string[] = [
  // Natur & Tiere
  "Honig verdirbt nie. In ägyptischen Gräbern wurde 3000 Jahre alter, immer noch essbarer Honig gefunden.",
  "Oktopusse haben drei Herzen und neun Gehirne.",
  "Bananen sind biologisch gesehen Beeren, Erdbeeren hingegen nicht.",
  "Kühe haben beste Freunde und werden gestresst, wenn sie von ihnen getrennt werden.",
  "Schweine können nicht zum Himmel schauen, ohne sich auf den Rücken zu legen.",
  "Wombat-Kot ist würfelförmig.",
  "Eine Gruppe Flamingos heisst auf Englisch \"flamboyance\".",
  "Eichhörnchen vergessen, wo sie ihre Nüsse vergraben haben, und pflanzen so Wälder.",
  "Tintenfische können ihre Hautfarbe in Sekundenbruchteilen ändern, obwohl sie farbenblind sind.",
  "Goldfische haben kein 3-Sekunden-Gedächtnis, sondern können sich monatelang erinnern.",
  "Adler können viermal so weit sehen wie Menschen.",
  "Schmetterlinge schmecken mit ihren Füssen.",
  "Bambus kann bis zu 91 cm pro Tag wachsen.",
  "Es gibt mehr Bäume auf der Erde als Sterne in der Milchstrasse.",
  "Faultiere bewegen sich so langsam, dass Algen auf ihrem Fell wachsen können.",
  "Ein Eisbär hat schwarze Haut unter seinem weissen Fell.",
  "Pinguine machen ihrem Partner einen Antrag mit einem perfekt gewählten Kieselstein.",
  "Das Herz eines Kolibris kann über 1200 Mal pro Minute schlagen.",
  "Delfine geben sich gegenseitig Namen: einzigartige Pfeiftöne, mit denen sie sich rufen.",
  "Tigerstreifen sind nicht nur im Fell, sondern auch in der Haut darunter.",
  "Eine Weinbergschnecke kann bis zu drei Jahre am Stück schlafen.",
  "Tintenfischblut ist blau, weil es Kupfer statt Eisen transportiert.",
  "Krokodile können ihre Zunge nicht herausstrecken.",
  "Quallen gibt es seit über 500 Millionen Jahren, das macht sie älter als Bäume.",
  "Ein Schneckenherz schlägt etwa 60 Mal pro Minute, fast gleich schnell wie deins.",
  "Eine Giraffe hat genauso viele Halswirbel wie ein Mensch: sieben.",
  "Kängurus können nicht rückwärts hüpfen.",
  "Seepferdchen-Männchen tragen den Nachwuchs aus, nicht die Weibchen.",
  "Otter halten beim Schlafen die Pfoten ihrer Partner, damit sie nicht abtreiben.",
  "Ein Kuhrülpser enthält mehr Methan als ihr Furz.",

  // Weltall & Wissenschaft
  "Auf der Venus regnet es Schwefelsäure. Man ist froh, nicht dort zu sein.",
  "Der Mond entfernt sich jedes Jahr etwa 3,8 cm von der Erde.",
  "Astronauten wachsen im Weltall bis zu 5 cm und schrumpfen danach wieder zurück.",
  "Pluto wurde 1930 entdeckt und 2006 zum Zwergplaneten herabgestuft.",
  "Die ISS umkreist die Erde alle 90 Minuten.",
  "Ein Blitz ist heisser als die Oberfläche der Sonne: etwa 30'000 °C.",
  "Saturn würde im Wasser schwimmen, denn er ist weniger dicht als Wasser.",
  "Ein Tag auf der Venus ist länger als ein Jahr auf der Venus.",
  "Auf dem Mars steht der höchste Berg des Sonnensystems: Olympus Mons, fast dreimal so hoch wie der Everest.",
  "Die Sonne macht rund 99,86 % der Masse unseres Sonnensystems aus.",
  "Würde man einen Würfelzucker auf einen Neutronenstern legen, würde er etwa 10 Millionen Tonnen wiegen.",
  "Dieses Phänomen, bei dem Wasser gleichzeitig kocht und gefriert, nennt sich Tripelpunkt.",
  "Die durchschnittliche Wolke wiegt rund 500 Tonnen.",
  "Im Universum gibt es mehr Sterne als Sandkörner an allen Stränden der Erde.",
  "Es regnet auch auf Titan, einem Saturnmond, allerdings flüssiges Methan.",
  "Schwarze Löcher sind nicht schwarz, sondern senden Strahlung aus, wie Stephen Hawking entdeckte.",

  // Geschichte & Gesellschaft
  "Cleopatra lebte näher an der Erfindung des iPhones als am Bau der Grossen Pyramide.",
  "Die Universität Oxford ist älter als das Aztekenreich.",
  "Napoleon wurde einmal von einer Bande Kaninchen angegriffen.",
  "Im Mittelalter hielten viele Tomaten für giftig.",
  "Der kürzeste Krieg der Geschichte dauerte 38 Minuten (Anglo-Sansibarischer Krieg, 1896).",
  "Die alten Römer benutzten Urin als Mundwasser.",
  "Die Wikinger brachten Skifahren nach Europa. Die ältesten Skier sind 5000 Jahre alt.",

  // Mensch & Körper
  "Knochen sind kilogrammweise rund fünfmal stärker als Stahl.",
  "Im Mund leben mehr Bakterien als Menschen auf der Erde.",
  "Dein Gehirn verbraucht rund 20 % deiner Energie, obwohl es nur 2 % deines Körpergewichts ausmacht.",
  "Du blinzelst im Schnitt 17 Mal pro Minute, das sind über 8 Millionen Mal pro Jahr.",
  "Im Schnitt verbringt ein Mensch sechs Monate seines Lebens an roten Ampeln.",
  "Dein Magen produziert alle paar Tage eine neue Schleimhaut, sonst würde er sich selbst verdauen.",
  "Du atmest pro Tag etwa 23'000 Mal ein und aus.",
  "Das längste je gemessene menschliche Niesen hielt 977 Tage am Stück an: Donna Griffiths, 1981.",

  // Weirde Tier-Fakten
  "Nacktmulle sind fast immun gegen Krebs und können über 30 Jahre alt werden, was für Nagetiere extrem ist.",
  "Fangschreckenkrebse sehen mit 16 verschiedenen Farbrezeptoren, während wir nur drei haben.",
  "Pistolenkrebse knallen ihre Schere so schnell zu, dass eine Blase entsteht, die kurzzeitig heisser ist als die Sonnenoberfläche.",
  "Bärtierchen überleben sogar im Vakuum des Weltalls und im kochenden Wasser.",
  "Eulen haben asymmetrische Ohren: Eines sitzt höher als das andere, was beim Orten von Beute hilft.",
  "Flusspferde schwitzen ein rotes, öliges Sekret aus, das wie eine eingebaute Sonnencreme wirkt.",
  "Haie gab es schon vor den Bäumen, denn sie schwimmen seit über 400 Millionen Jahren in den Meeren.",
  "Seeotter haben Hauttaschen unter den Achseln, in denen sie ihre Lieblings-Werkzeuge aufbewahren.",
  "Axolotl können verlorene Gliedmassen, Organe und sogar Teile ihres Gehirns nachwachsen lassen.",
  "Sternmulle sind die schnellsten Esser der Welt: Sie identifizieren Beute in 0,2 Sekunden.",
  "Faultiere koten nur einmal pro Woche und verlieren dabei bis zu 30 % ihres Körpergewichts.",
  "Mimik-Oktopusse können über 15 verschiedene Meereslebewesen imitieren, von Seeschlangen bis Plattfischen.",
  "Flamingos sind rosa, weil sie Krebstiere mit Karotinoiden fressen, die sie einfärben.",
  "Waldfrösche frieren im Winter komplett ein, Herz und Hirn eingeschlossen, und tauen im Frühling lebend wieder auf.",
  "Schnecken haben rund 14'000 winzige Zähnchen auf einer einzigen Raspelzunge.",
  "Hummeln können menschliche Gesichter erkennen und sich an einzelne Personen erinnern.",
  "Glasfrösche haben durchsichtige Bauchhaut, durch die man ihr Herz schlagen sieht.",
  "Schuppentiere sind das einzige Säugetier mit Keratin-Schuppen am ganzen Körper, wie ein lebender Tannenzapfen.",
  "Strausse haben Augen, die grösser sind als ihr Gehirn.",
  "Die Zunge eines Blauwals kann so viel wiegen wie ein ausgewachsener Elefant.",
  "Hornechsen können bei Gefahr Blut aus ihren Augen spritzen, bis zu 1,5 m weit.",
  "Vampirfledermäuse teilen ihre Blutmahlzeiten mit hungrigen Artgenossen und merken sich, wer revanchiert.",
  "Ameisen schlafen nicht durch, sondern machen rund 250 Mini-Nickerchen pro Tag, je etwa eine Minute lang.",
  "Tauben bestehen den Spiegel-Test und können bei Mathe-Aufgaben mit Primaten mithalten.",
  "Leierschwänze imitieren so gut, dass sie Kettensägen, Kamera-Klicks und Autoalarme nachmachen können.",
  "Ein Tintenfisch kann sich durch ein Loch quetschen, das so gross ist wie sein Augapfel.",

  // Sprache, Tech & Kultur
  "Es gibt mehr Möglichkeiten, ein 52er Kartenspiel zu mischen, als Atome auf der Erde.",
  "Der Buchstabe \"E\" ist der häufigste Buchstabe in der deutschen Sprache.",
  "Wenn du jeden Tag ein neues Wort lernst, kennst du nach 10 Jahren über 3'650 zusätzliche Wörter.",
  "Das Wort \"Roboter\" stammt aus dem Tschechischen und bedeutet \"Frondienst\".",
  "\"Sandwich\" ist nach einem Earl benannt, der beim Kartenspielen nicht aufstehen wollte.",
  "Bluetooth ist nach Wikingerkönig Harald Blauzahn benannt, dessen Initialen das Logo in Runen zeigt.",
  "Das @-Zeichen ist über 500 Jahre alt: Kaufleute benutzten es als Mengenangabe.",
  "Der erste Computer-Bug war wörtlich ein Bug: eine Motte im Relais des Mark II, 1947.",
  "Die Apollo-11-Computer hatten weniger Rechenleistung als eine heutige Mikrowelle.",
  "Coca-Cola ist eine der meistgesprochenen Wortmarken der Welt, gleich nach \"OK\".",
  "Jeden Tag fliegen rund 100'000 Flugzeuge gleichzeitig irgendwo über uns.",
  "Wikipedia hat in über 300 Sprachen Artikel und wird komplett von Freiwilligen geschrieben.",
  "Das längste Wort im Duden hat 79 Buchstaben: \"Donaudampfschifffahrtselektrizitäten…\" und so weiter.",
  "Der erste Tweet wurde am 21. März 2006 abgesetzt: \"just setting up my twttr\".",
  "Das erste Foto, das je ins Web hochgeladen wurde, zeigte eine Comedy-Band namens \"Les Horribles Cernettes\" (1992).",

  // Essen & Pflanzen
  "Ananas brauchen rund zwei Jahre, bis sie reif sind.",
  "Karotten waren ursprünglich lila. Orange wurden sie erst im 17. Jahrhundert in den Niederlanden gezüchtet.",
  "Kakaobohnen waren bei den Azteken so wertvoll, dass sie als Währung benutzt wurden.",
  "Tomatenpflanzen haben mehr Gene als Menschen.",
  "Erdnüsse sind keine Nüsse, sondern Hülsenfrüchte, näher verwandt mit Bohnen.",
  "Avocados sind technisch gesehen eine einzige grosse Beere.",
  "Vanille ist nach Safran das zweitteuerste Gewürz der Welt.",
  "Pizza Margherita wurde 1889 für die italienische Königin Margherita erfunden, in den Farben der Flagge.",

  // Eiffelturm — kept because it's a classic
  "Der Eiffelturm wird im Sommer etwa 15 cm höher, weil sich das Eisen ausdehnt.",
];
